
import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import CustomAddIcon from "@/components/icons/CustomAddIcon";
import AddBoardForm from "./AddBoardForm";

interface AddBoardButtonProps {
  className?: string;
  variant?: "default" | "outline" | "secondary" | "icon" | "circle";
  id?: string;
  showHoverText?: boolean;
}

const AddBoardButton = ({ 
  className, 
  variant = "circle", 
  id,
  showHoverText = true
}: AddBoardButtonProps) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleMouseEnter = () => {
    if (showHoverText) {
      setIsHovered(true);
    }
  };

  const handleMouseLeave = () => {
    if (showHoverText) {
      setIsHovered(false);
    }
  };

  return (
    <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
      <DialogTrigger asChild>
        <div 
          className={`flex items-center ${className}`}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          {isHovered && (
            <span className="text-[#0073FF] text-sm font-medium mr-2">Add</span>
          )}
          <CustomAddIcon 
            size={24} 
            variant={isHovered ? "blue" : "gray"} 
          />
        </div>
      </DialogTrigger>
      {/* Always render dialog content - no conditional rendering */}
      <DialogContent className="sm:max-w-[550px]">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold">Create New Board</DialogTitle>
        </DialogHeader>
        <AddBoardForm onComplete={() => setIsDialogOpen(false)} />
      </DialogContent>
    </Dialog>
  );
};

export default AddBoardButton;
